export const Href: string = "#";

//brands
export const AddBrandTitle: string = "Add Brand";
export const ViewBrandTitle: string = "View Brand";
export const EditBrandTitle: string = "Edit Brand";
export const BrandTitle: string = "Brand";
export const ViewAddBrandTitle: string = "Add/View Brand";
export const ViewEditBrandTitle: string = "Edit/View Brand";


//model
export const AddVehicleModelTitle: string = "Add Vehicle Model";
export const ViewVehicleModelTitle: string = "View Vehicle Model";
export const EditVehicleModelTitle: string = "Edit Vehicle Model";
export const VehicleModelTitle: string = "Vehicle Model";

//languages
export const AddLanguageTitle: string = "Add Language";
export const ViewLanguageTitle: string = "View Language";
export const EditLanguageTitle: string = "Edit Language";
export const LanguageTitle: string = "Language";

//agents
export const AddAgentTitle: string = "Add Agent";
export const ViewAgentTitle: string = "View Agent";
export const EditAgentTitle: string = "Edit Agent";
export const AgentTitle: string = "Agent";
export const CallHistoryTitle: string = "Call History";
export const VideoCallHistoryTitle: string = "Video Call History";
//customers
export const ViewCustomerTitle: string = "View Customer";
export const CustomerTitle: string = "Customer";
export const PackageBoughtTitle: string = "Package Bought";

//generalSettings
export const AddGeneralSettingTitle: string = "Add General Setting";
export const ViewGeneralSettingTitle: string = "View General Setting";
export const EditGeneralSettingTitle: string = "Edit General Setting";
export const GeneralSettingTitle: string = "General Setting";

//packages
export const AddPackageTitle: string = "Add Audio Package";
export const ViewPackageTitle: string = "View Audio Package";
export const EditPackageTitle: string = "Edit Audio Package";
export const PackageTitle: string = "Package";

//packages
export const AddVideoPackageTitle: string = "Add Video Package";
export const ViewVideoPackageTitle: string = "View Video Package";
export const EditVideoPackageTitle: string = "Edit Video Package";

//dashboard
export const TopAgentTitle: string = "Top Agent"
export const TotalProfitTitle: string = "Total Profit"
export const CustomerCreditTitle: string = "Customer Credit";
export const TotalData: string = "Total Data"


//expense
export const AddExpenseTitle: string = "Add Expense";
export const ViewExpenseTitle: string = "View Expense";
export const EditExpenseTitle: string = "Edit Expense";
export const ExpenseTitle: string = "Expense";
export const ViewAddExpenseTitle: string = "Add/View Expense";
export const ViewEditExpenseTitle: string = "Edit/View Expense";

//PackagePaymentSetting
export const AddPackagePaymentSettingTitle: string = "Add Audio Package Payment Setting";
export const ViewPackagePaymentSettingTitle: string = "View Audio Package Payment Setting";
export const EditPackagePaymentSettingTitle: string = "Edit Audio Package Payment Setting";
export const PackagePaymentSettingTitle: string = "Package Payment Setting";

//PackagePaymentSetting
export const AddVideoPackagePaymentSettingTitle: string = "Add Video Package Payment Setting";
export const ViewVideoPackagePaymentSettingTitle: string = "View Video Package Payment Setting";
export const EditVideoPackagePaymentSettingTitle: string = "Edit Video Package Payment Setting";

//reports
export const CallReportTitle: string = "Call Report";
export const ReportTitle: string = "Report";

//smssetting
export const AddSmsSettingTitle: string = "Add SMS Setting";
export const ViewSmsSettingTitle: string = "View SMS Setting";
export const EditSmsSettingTitle: string = "Edit SMS Setting";
export const SmsSettingTitle: string = "SMS Setting";

//paymentsetting
export const AddPaymentSettingTitle: string = "Add Payment Setting";
export const ViewPaymentSettingTitle: string = "View Payment Setting";
export const EditPaymentSettingTitle: string = "Edit Payment Setting";
export const PaymentSettingTitle: string = "Payment Setting";

//withdrawalsetting
export const WithdrawalSettingTitle: string = "Withdrawal Setting";
export const Setting: string = "Setting";


//support
export const CustomerSupportTitle: string = "Customer Support";
export const AgentSupportTitle: string = "Agent Support";
export const Support: string = "Support";
















//Layout
export const Dollar: string = "$";
export const Pinned: string = "Pinned";
export const Cart: string = "Cart";
export const GoToCart: string = "Go to your cart";
export const Checkout: string = "Checkout";
export const NotificationTitle: string = "Notification";
export const Bookmark: string = "Bookmark";

//Typography
export const UiKits: string = 'Ui Kits';
export const TypographyTitle: string = 'Typography';
export const HeadingsTitle: string = 'Headings';
export const ColoredHeadingTitle: string = 'Colored Headings';
export const FontWeightTitle: string = "Font weight";

//List
export const ListsTitle: string = "Lists";
export const DefaultListTitle: string = "Default Lists";
export const ActiveListTitle: string = "Active Lists";
export const FlushListTitle: string = "Flush Lists";
export const ContextualClassTitle: string = "Contextual classes";
export const HorizontalListTitle: string = "Horizontal Lists";
export const CustomListTitle: string = "Custom Content Lists";
export const ListWithCheckboxTitle: string = "Lists With Checkboxs";
export const ListWithRadioTitle: string = "Lists With Radios";
export const ListWithNumberTitle: string = "Lists With Numbers";
export const JsBehaviorTitle: string = "JavaScript Behavior";
export const NumberedBadgeListTitle: string = "Numbered & Badge Lists";
export const DisableListTitle: string = "Disabled Lists";
export const ScrollableListTitle: string = "Scrollable Lists";

//Bonus ui
export const BonusUi: string = "Bonus Ui";
export const ScrollableTitle: string = "Scrollable";
export const CustomScrollbarTitle: string = "Custom Scrollbar"
export const SmallSizeScrollTitle: string = "Small Size Scrollbar"
export const BadgesScrollbarTitle: string = "Badges Scrollbar";
export const ProfileScrollableTitle: string = "Profile Scrollable";
export const ScrollableContentTitle: string = "Scrollable Content";
export const HorizontalScrollbarTitle: string = "Horizontal Scrollbar";
export const BothSideScrollbarTitle: string = "Both Side Visible Scrollbar";
//Tree View
export const TreeViewTitle: string = "Tree View";
export const BasicTreeTitle: string = "Basic Tree";
export const DisabledTreeTitle: string = "Disabled Tree";
//Toasts
export const ToastsTitle: string = "Toasts";
export const LiveToastTitle: string = "Live Toast";
export const ColorsSchemesTitle: string = "Colors Schemes";
export const StackingToastsTitle: string = "Stacking Toasts";
export const TranslucentToastsTitle: string = "Translucent Toasts";
export const DefaultToastTitle: string = "Default Toast";
export const UniqueToastTitle: string = "Unique Toast";
export const ToastPlacementTitle: string = "Toast Placement";
//Tab bootstrap
export const TabBootstrapTitle: string = "Tab bootstrap";
export const JustifyTabTitle: string = "Justify Tabs";
export const MaterialLeftStyleTabTitle: string = "Material Style Left Tabs";
export const MaterialStyleTabTitle: string = "Material Style Tabs";
export const BorderTabsTitle: string = "Border Tabs";
//Dropdown
export const DropdownTitle: string = "Dropdown";
export const BasicDropdownTitle: string = "Basic Dropdown";
export const RoundedDropdownTitle: string = "Rounded Dropdown";
export const SplitDropdownTitle: string = "Split Dropdown";
export const HeadingDropdownTitle: string = 'Heading Dropdown';
export const DropdownWithInputTitle: string = "With Input Type";
export const DarkDropdownTitle: string = "Dark Dropdown";
export const UniqueDropdownTitle: string = "Unique Dropdown";
export const JustifyContentTitle: string = "Justify Contents";
export const AlignmentsTitle: string = "Alignments";
export const HelperCardTitle: string = "Helper Card";
export const DividerDropdownTitle: string = "Divider Dropdown";
export const DropdownSizingTitle: string = "Dropdown Sizing";
//Modal
export const ModalTitle: string = "Modal";
export const BasicModalTitle: string = "Basic Modal"
export const ScrollingContent: string = "Scrolling content";
export const SizeModalTitle: string = "Sizes Modal";
export const FullscreenModalTitle: string = "Fullscreen Modal";
export const CenteredModalTitle: string = "Centered Modal";
export const NestedModalTitle: string = "Nested Modal";
export const StaticModalTitle: string = "Static Backdrop Modal";
export const CustomModalsTitle: string = "Admiro custom modals";
//Tab bootstrap
export const SimpleTabTitle: string = "Simple tabs";
export const IconTabsTitle: string = "Icons With Tabs";
export const VerticalTabTitle: string = "Vertical Tabs";
export const PillsTabTitle: string = "Pills tabs";
//Accordion
export const AccordionTitle: string = "Accordion";
export const SimpleAccordionTitle: string = "Simple Accordion";
export const FlushAccordionTitle: string = "Flush Accordion";
export const MultipleCollapseTitle: string = "Multiple Collapse Accordion";
export const IconAccordionTitle: string = "With Icons Accordion";
export const OutlineAccordionTitle: string = "Outline Accordion";
export const HorizontalAccordionTitle: string = "Horizontal Accordion";
export const CollapesAccordionTitle: string = "Collapse Accordion";
//Tag pills
export const TagPillsTitle: string = "Tag pills";
export const BadgesContextualTitle: string = "Badges";
export const PillsContextualTitle: string = "Pills";
export const NumberBadgesTitle: string = "Number Badges";
export const NumberPillsTitle: string = "Number Pills";
export const BadgeIconTitle: string = "Icon With Badge";
export const PillIconsTitle: string = "Icon With Pills";
export const BadgeHeadingsTitle: string = "Badge Headings";
export const BadgeButtonsTitle: string = "Badges With Buttons";
//Progress bar
export const ProgressBarTitle: string = "Progress bar";
export const BasicProgressTitle: string = "Progress Bars";
export const ProgressStriped: string = "Striped Bar";
export const ProgressAnimated: string = "Animated Bar";
export const MultipleBarsTitle: string = "Multiple bars";
export const StepsBarTitle: string = "Steps Bar";
export const CustomProgressTitle: string = "Custom Bars";
export const SmallProgressTitle: string = "Small Progress Bars";
export const LargeProgressTitle: string = "Large Progress Bars";
export const CustomSizesTitle: string = "Custom Sizes";
//Tooltip
export const TooltipTitle: string = "Tooltip";
export const BasicTooltipTitle: string = "Basic Tooltip";
export const ColoredTooltipTitle: string = "Colored Tooltip";
export const TooltipDirectionTitle: string = "Tooltip Directions";
export const HtmlTooltipTitle: string = 'HTML Elements With Tooltip';
export const FilledTooltipTitle: string = 'Filled Tooltip';
//Helper classes
export const HelperClassTitle: string = 'Helper classes';
export const BordersTitle: string = 'Borders';
export const AdditiveBorderTitle: string = "Additive Border";
export const SubtractiveBorderTitle: string = "Subtractive Border";
export const AdditiveRadiusTitle: string = "Additive Radius";
export const BorderStyleTitle: string = 'Borders Style';
export const CustomBorderTitle: string = "Custom Border-radius Class";
export const BorderColorTitle: string = 'Border Color';
export const BorderWidthTitle: string = "Border-Width";
export const TextColorsTitle: string = "Text Colors";
export const BackgroundColorsTitle: string = "Background Colors";
export const DarkBackgroundTitle: string = "Dark Background";
export const LightBackgroundsTitle: string = "Light Backgrounds";
export const ExtendedBackgroundTitle: string = "Extended Background Colors";
export const ImageSizeTitle: string = "Images Sizes";
export const FontStyleTitle: string = "Font-Style";
export const FontSizeTitle: string = "Font Sizes";
// Grid
export const GridTitle: string = 'Grid';
export const GridOptionsTitle: string = "Grid Options";
export const GridColumnTitle: string = "Column Grid";
export const VerticalAlignmentTitle: string = "Vertical Alignment";
export const HorizontalAlignmentTitle: string = "Horizontal Alignment";
export const NestingTitle: string = "Nesting";
export const OrderTitle: string = 'Order';
export const OffsetTitle: string = "Offset";
//Popover
export const PopoverTitle: string = 'Popover';
export const BasicPopoverTitle: string = "Basic Popover";
export const PopoverDirectionTitle: string = "Popover Direction";
export const PopoverOffsetTitle: string = "Popover Offset";
export const ListingTypography: string = 'Listing Typography';
export const UnorderListTitle: string = "Unorder list";
export const OrderListTitle: string = "Order list";
export const DescriptionListTitle: string = "Description list";
export const DisplayHeadingTitle: string = "Display headings";
export const Inlinetextelements: string = "Inline text elements";
export const TextColorTitle: string = "Text Color";
export const BlockquotesTitle: string = "Blockquotes";

//Avatars
export const Avatars: string = "Avatars";
export const Sizes: string = 'Sizes';
export const StatusIndicatorTitle: string = 'Status Indicator';
export const ShapesTitle: string = 'Shapes';
export const RatioTitle: string = 'Ratio';
export const GroupingTitle: string = 'Grouping';
export const AvatarInitialTitle: string = "Avatar Initial"
export const AvatarPingTitle: string = "Avatar Ping"
export const AvatarProfileTitle: string = "Avatar Profile"

//Alert
export const Alert: string = "Alert";
export const LinkColorTitle: string = "Link Color In Dark Theme";
export const LinkLightColorTitle: string = "Link Color In Light Theme";
export const OutlineAlertTitle: string = "Outline Alert"
export const AlertWithIconsTitle: string = "Alerts with Icons";
export const DismissingDarkAlertTitle: string = "Dismissing Dark Alert";
export const DismissingLightAlertTitle: string = "Dismissing Light Alerts";
export const LiveAlertTitle: string = 'Live Alert';
export const ShowLiveAlert: string = "Show live alert";
export const LeftBorderAlertTitle: string = "Left Border Alert";
export const AdditionalAlertTitle: string = 'Additional Content';

//Ecommerce
//Add-product
export const ECommerceTitle: string = "ECommerce";
export const AddProductTitle: string = "Add Product";
export const ProductForm: string = "Product Form";
export const ProductTitleLabel: string = "Product Title";
export const AddCategory: string = "Add Category";
export const CreateNewCategory: string = "Create New Category";
export const CategoryName: string = "Category Name";
export const Add: string = "Add";
export const PublishStatus: string = "Publish Status";
export const PublishDateTime: string = "Publish Date & Time";
export const TooltipLabelText: string = "Types of product discount";
export const InitialCost: string = "Initial cost";
export const SellingPriceText: string = "Selling price";
export const ChooseYourCurrency: string = "Choose your currency";
export const ProductStocks: string = "Product stocks";
export const InventoryText: string = "Inventory";
export const AdditionalOptionText: string = 'Additional Options';
export const ShippingText: string = 'Shipping';
export const StockAvailability: string = "Stock Availability";
export const LowStock: string = 'Low Stock';
export const Sku: string = 'SKU';
export const StockQuantity: string = "Stock Quantity";
export const RestockDate: string = "Restock Date";
export const PreOrder: string = "Pre-Order";
export const AllowBackorders: string = "Allow Backorders";
export const DigitalProduct: string = "This is a digital Product";
export const AdditionalTagTitle: string = "Additional Tag Title";
export const SpecificTags: string = "Specific Tags";
export const OrderPickupLabel: string = "Where can I pick up my order?";
export const WeightLabel: string = "Weight (kg)";
export const DimensionsLabel: string = "Dimensions";
export const ShippingClass: string = "Shipping Class";
export const Cancel: string = "Cancel";

//Product
export const ProductTitle: string = "Product";
export const STEP = 10;
export const MIN = 25;
export const MAX = 100;
//To-do
export const ToDoTitle: string = "To-Do";
export const ToDoFilter: string = "To Do filter";
export const ToDoList: string = "To Do List";

//Search Pages
export const SearchPagesTitle: string = "Search Pages";
export const SearchWebsiteTitle: string = "Search Website"
export const ProductPageTitle: string = "Product Page";
//Calendar
export const CalenderBasicTitle: string = "Calender Basic";
export const CalendarFilter: string = "calendar filter";
export const DraggableEventsTitle: string = "Draggable Events";
export const RemoveAfterDrop: string = "remove after drop";

//Social App
export const SocialAppTitle: string = "Social App";
export const MutualFriendsTitle: string = "Mutual Friends";
export const ActivityFeedTitle: string = "Activity Feed";
export const ProfileIntroTitle: string = "Profile Intro";
export const Followers: string = "Followers";
export const FollowingsTitle: string = "Followings";
export const LatestPhotosTitle: string = "Latest Photos";
export const FriendsTitle: string = "Friends";
export const PepoleKnownTitle: string = "Pepole You May Know";
export const ViewedProfileTitle: string = "Viewed Your Profile";
export const ActivityLogTitle: string = "Activity Log";
//Contacts
export const ContactsTitle: string = "Contacts";
export const ContactFilter: string = "contact filter"
export const OrgenizationTitle: string = "Organization";
export const FollowUp: string = "Follow Up";
export const Ideas: string = "Ideas";
export const Personal: string = "Personal";
export const EditMoreInformation: string = "Edit more information";
export const PrintPreview: string = "Print Preview";

//Tasks
export const TasksTitle: string = "Tasks";
export const TaskFilter: string = "task filter";
export const NewTaskTitle: string = "New Task";
export const TaskTitleLabel: string = "Task Title";
export const SubTaskTitle: string = "Sub task";
export const TodayTasks: string = "Today's Tasks";
export const DelayedTasks: string = "Delayed Tasks";
export const UpcomingTasks: string = "Upcoming Tasks";
export const ThisWeekTasks: string = "This week tasks";
export const ThisMonthTasks: string = "This month tasks";
export const AssignedToMe: string = "Assigned to me";
export const MyTasks: string = "My tasks";
//Users
export const UsersTitle: string = "Users";
export const UserProfileTitle: string = "User Profile";
export const UserCardsTitle: string = "User Cards";

//Bookmark
export const BookmarksTitle: string = "Bookmarks"
export const BookmarkFilter: string = "bookmark filter";
export const NewBookmark: string = "New Bookmark";
export const AddBookmark: string = "Add Bookmark";
export const WebUrl: string = "Web Url";
export const Group: string = "Group";
export const Collection: string = "Collection";
export const CreateTag: string = "Create Tag";
export const TagName: string = "Tag Name";
export const TagColor: string = "Tag color";
export const CreatedByMe: string = "Created by me";
export const SharedWithMe: string = 'Shared with me';
export const MyBookmark: string = "My bookmark";
export const Notification: string = "notification";
export const Favourites: string = "Favourites";
export const Important: string = "Important";
export const Organization: string = "Organization";
export const Newsletter: string = "Newsletter";
export const Business: string = "Business";
export const Holidays: string = "Holidays";
export const EditBookmark: string = "Edit Bookmark";
export const Description: string = "Description";
export const Title: string = "Title";
export const Save: string = "Save";
//Dashboard
export const TotalInvestTitle: string = "Total Invest";
export const ManageInvoiceTitle: string = "Manage Invoice";

//Ecommerce
export const EcommerceTitle: string = "Ecommerce";
export const EcommerceDashboardTitle: string = "Ecommerce dashboard";
export const SalesAnalyticsTitle: string = "Sales Analytics";
export const UserStatusTitle: string = "User Status";
export const SellingProductTitle: string = "Top Selling Products";
export const BestSellTitle: string = "Best Seller";
export const ActivityTimelineTitle: string = "Activity Timeline";
export const RecentOrdersTitle: string = "Recent Orders";
//Project
export const EducationTitle: string = "Education";
export const EducationDashboardTitle: string = "Education Dashboard";
export const UpcomingClassesTitle: string = "Upcoming Classes";
export const ScheduleLessonTitle: string = "Schedule a lesson";

//Widgets
export const WidgetsTitle: string = "Widgets";
export const GeneralTitle: string = "General";
//Chart
export const ChartTitle: string = "Chart";
export const MonthlyHistoryTitle: string = "Monthly History";
export const SkillStatusTitle: string = "Skill Status";
export const OrderStatusTitle: string = "Order Status";
export const LiveProductsTitle: string = "Live Products";
export const TurnOverTitle: string = "Turn over";
export const StockMarketTitle: string = "Stock Market";

//Application
export const ApplicationTitle: string = "Application";
export const ProjectListTitle: string = "Project list";
export const CreateNewProject: string = "Create New Project";
export const ProjectTitleLabel: string = "Project Title";
export const ClientName: string = "Client name";
export const ProjectRate: string = "Project Rate";
export const ProjectType: string = "Project Type";
export const Hourly: string = "Hourly";
export const FixPrice: string = "Fix price";
export const Priority: string = "Priority";
export const Low: string = "Low";
export const Medium: string = "Medium";
export const High: string = "High";
export const Urgent: string = "Urgent";
export const ProjectSize: string = "Project Size";
export const Small: string = "Small";
export const Big: string = "Big";
export const StartingDate: string = "Starting date";
export const EndingDate: string = "Ending date";
export const EnterSomeDetails: string = "Enter some Details";
export const UploadProjectFile: string = "Upload project file";

//File manager
export const FileManagerTitle: string = "File manager";
export const FileFilter: string = "file filter";

//Letter box
export const EmailTitle: string = "Email";
export const LetterBoxTitle: string = "Letter Box";
export const EmailFilter: string = "email filter";
export const ComposeEmail: string = "Compose Email";
export const AddLabel: string = "Add Label";
export const ComposeMessage: string = "Compose Message";
export const SaveDraft: string = "Save as draft";
export const Send: string = "Send";

//Chat
export const ChatTitle: string = "Chat";
export const PrivateChatTitle: string = "Private Chat";
export const GroupChatTitle: string = "Group Chat";

//Users
//Users-edit
export const EditProfileTitle: string = "Edit Profile";
export const Bio: string = "Bio";
export const Website: string = "Website";
export const Company: string = "Company";
export const AboutMe: string = "About Me";
export const UpdateProfile: string = "Update Profile";
export const AddProjectsAndUploadTitle: string = "Add projects and Upload";
export const MyProfileTitle: string = "My Profile";
export const Address: string = "Address";
export const Country: string = "Country";
export const FirstName: string = "First name";
export const LastName: string = "Last name";
export const PostalCode: string = "Postal Code";
export const SchoolPerformanceTitle: string = "School Performance";
export const NoticeBoardTitle: string = "Notice Board";
export const StudentDetailsTitle: string = "Student Details";
export const NewCoursesTitle: string = "New Courses";
export const TimeSpentLearning: string = "Time Spent on Learning";
export const ToDoListTitle: string = "To-do list";
export const AssignmentsTitle: string = "Assignments";
//Job search
export const JobSearchTitle: string = "Job search";
export const CardViewTitle: string = "Card View";
export const ListViewTitle: string = "List View";
export const JobDetailsTitle: string = "Job Details";
export const JobFilter: string = "Job Filter";
export const ProductDesignerTitle: string = "Product Designer (UI/UX Designer)";
export const Apply: string = "Apply";
export const JobDescription: string = "Job Description";
export const SaveThisJob: string = "Save this job";
export const Share: string = "Share";
export const SimilarJobs: string = "Similar Jobs";
export const UIDesigner: string = "UI Designer";
export const PersonalDetailsTitle: string = "Personal Details";
export const FullName: string = "Full name"
export const BirthDate: string = "Birth Date";
export const RepeatPassword: string = "Repeat Password";
export const YourEducationTitle: string = "Your Education";
export const CollegeName: string = "College Name";
export const Period: string = "Period";
export const DegreeLevel: string = "Degree Level";
export const Specialization: string = "Specialization";
export const YourExperienceTitle: string = "Your Experience";
export const Position: string = "Position";
export const CompanyName: string = "Company Name";
export const UploadYourFiles: string = "Upload Your Files";
export const UploadCoverLetter: string = "Upload Cover Letter";
export const UploadYourCV: string = "Upload Your CV";
export const UploadRecommendations: string = "Upload Recommendations";
export const Location: string = "Location";

//Learning
export const LearningTitle: string = "Learning"
export const LearningListTitle: string = "Learning List"
export const LearningDetailedTitle: string = "Learning detailed"
export const LearningFilterTitle: string = "Learning filter";
export const FindCourse: string = "Find Course";
export const Filter: string = "Filter";
export const CategoriesTitle: string = "Categories";
export const UpcomingCoursesTitle: string = "Upcoming Courses";

//Maps
export const MapTitle: string = "Map"
export const GoogleMapTitle: string = "Google Map"
export const BasicMapTitle: string = "Basic Map";
export const MarkerMapTitle: string = "Marker Map";
export const PolygonsTitle: string = "Polygons";
export const PolylinesTitle: string = "Polylines";
export const LeafletMapTitle: string = "Leaflet Map";
export const WorldMapTitle: string = "Leaflet World Map";
export const UsaMapTitle: string = "Leaflet Usa Map";
export const IndiaMapTitle: string = "Leaflet India Map";
export const AustraliaMapTitle: string = "Leaflet Australia Map"

//Editor
export const EditorTitle: string = "Editor"
export const QuillEditorTitle: string = "Quill Editor"
export const AceCodeEditorTitle: string = "ACE Code Editor"
export const JavascriptModeTitle: string = "Javascript Mode";
export const HTMLModeTitle: string = "Html Mode";
export const CssModeTitle: string = "Css Mode";
export const PhpModeTitle: string = "Php Mode";
export const StandardEditorTitle: string = "Standard Editor"
export const SnowThemeTitle: string = "Snow Theme";
export const BubbleThemeTitle: string = "Bubble Theme";

//Support Ticket
export const SupportTicketTitle: string = "Support Ticket"
export const SupportTicketList: string = "Support Ticket List";
export const Profit: string = "Profit";
export const Loss: string = "Loss";

//Dashboard
export const DashboardTitle: string = "Dashboard"
export const DefaultDashboardTitle: string = "Dashboard"
export const EarningsTrendTitle: string = "Earnings Trend"
export const JobToday: string = "Job Today"
export const TransitionHistoryTitle: string = "Transition History"
export const AuditLogTitle: string = "Audit log"
export const TotalInvestmentTitle: string = "Total Investment"
export const LatestActivityTitle: string = "Latest Activity"
export const MonthlyRevenueGrowth: string = "Monthly Revenue Growth"
export const TopUsersTitle: string = "Top Users"
export const NewsUpdateTitle: string = "News & Update"
//Gallery
export const GalleryTitle: string = "Gallery";
export const ImageHoverEffects: string = "Image Hover Effects";
export const MasonaryTitle: string = "Masonary";
export const MasonryGalleryTitle: string = "MASONRY GALLERY";
export const MasonaryDiscTitle: string = "Masonary with disc";
export const MasonryDescriptionTitle: string = "MASONRY GALLERY WITH DESCRIPTION";
export const HoverEffect: string = "Hover Effect";

//blog
export const BlogTitle: string = "Blog";
export const BlogDetailsTitle: string = "Blog details";
export const BlogSingleTitle: string = "Blog Single";
export const AddPostTitle: string = "Add Post";
export const Comment: string = "Comment";
export const PostEditTitle: string = "Post Edit";
export const Type: string = "Type";
export const Category: string = "Category";
export const Content: string = "Content";
export const Discard: string = "Discard";

//FAQ
export const FaqTitle: string = "FAQ";
export const QuickQuestionsTitle: string = "Quick Questions are answered";
export const SearchArticlesTitle: string = "Search Articles";
export const Navigation: string = "Navigation";
export const AskQuestion: string = "Ask Question";
export const LatestUpdatesTitle: string = "Latest Updates";
export const FeaturedTutorialsTitle: string = "Featured Tutorials";
export const LatestArticlesVideosTitle: string = "Latest Articles and Videos";

//Knowledgebase
export const KnowledgebaseTitle: string = "Knowledgebase";
export const BrowseArticlesTitle: string = "Browse articles by category";
export const BrowseArticlesHeader: string = "Browse Articles";
//auth
export const Done: string = "Done";
export const State: string = "State";
export const ConfirmPassword: string = "Confirm Password";
export const Previous: string = "Previous";
export const Next: string = "Next";
export const YourName: string = "Your Name";
export const Agreewith: string = "Agree with";
export const Unlock: string = "Unlock";
export const EnterYourPassword: string = "Enter your Password";
export const ResetYourPassword: string = "Reset Your Password";
export const EnterYourMobileNumber: string = "Enter Your Mobile Number";
export const Resend: string = " Resend ";
export const EnterOtp: string = "Enter OTP";
export const CreateYourPassword: string = "Create Your Password";
export const NewPassword: string = "New Password";
export const RetypePassword: string = "Retype Password";
export const MaintenanceTitle: string = "MAINTENANCE";
export const SignUpAccount: string = "Sign up to account";
export const Finish: string = "Finish";
export const Phone: string = "phone";
export const Birthday: string = "Birthday:";

//Gallery
export const ImageGalleryTitle: string = "IMAGE GALLERY";
export const GalleryGridDescriptionTitle: string = "Gallery Grid With Description";
export const ImageGalleryDescriptionTitle: string = "IMAGE GALLERY WITH DESCRIPTION";
//Tables
export const TablesTitle: string = "Tables";
export const TableComponentsTitle: string = "Table Components";
//table-components
export const UIComponentsTitle: string = 'UI Components';
export const AlertTitle: string = "Alert";
export const ProgressbarTitle: string = 'Progressbar';
export const CheckboxTitle: string = 'Checkbox';
export const RadioButtonsTitle: string = 'Radio Buttons';
export const Select: string = 'Select';
export const BadgesTitle: string = 'Badges';
export const TooltipTriggersTitle: string = 'Tooltip Triggers';
export const DefaultButtonsTitle: string = "Default Button";
export const Inputs: string = "Inputs";
//Data Tables
export const DataTablesTitle: string = "Data Tables";
export const BasicDataTablesTitle: string = "Basic Data Tables";
export const ZeroConfigurationTitle: string = "Zero Configuration";
export const StateSavingTableTitle: string = "State saving";
export const ScrollVerticalDynamicHeightTitle: string = "Scroll - vertical, dynamic height";
export const AdvanceInitTitle: string = "Advance Init";
export const StockResultTitle: string = "Stock Result";
export const RowCreateCallbackTitle: string = "Row Create Callback";
export const ApiDataTablesTitle: string = "API DataTables";
export const AddRowsTitle: string = "Add rows";
export const AddNewRow: string = "Add new row";
export const ChildRowsTitle: string = "Child rows (show extra / detailed information)";
export const RowsSelectionAndDeletionTitle: string = "Row Selection And Deletion (Single Row)";
export const DeleteRow: string = "Delete Row";
export const CustomFilteringTitle: string = "Custom filtering - range search";
export const DataSourceTitle: string = "DATA Source DataTables";
export const HtmlTableTitle: string = "HTML (DOM) Sourced Data";
export const AjaxSourcedDataTitle: string = "Ajax sourced data";
export const JavascriptSourcedDataTitle: string = "Javascript sourced data";
export const ServerSideProcessingTitle: string = "Server-side processing";

//Pages
export const PagesTitle: string = "Pages";
export const SamplePageTitle: string = "Sample Page";
export const SampleCardTitle: string = "Sample Card";
//Form Widgets
//typeahead
export const TypeaheadTitle: string = "Typeahead";
export const BasicTypeaheadTitle: string = 'Basic typeahead';
export const PrefetchTitle: string = 'Prefetch';
export const MultipleSelectInputTitle: string = 'Multiple select input';
export const SelectOneInputsTitle: string = 'Select one inputs';
export const MultipleSectionsHeadersTitle: string = 'Multiple sections with headers';
export const RTLSupportTitle: string = 'RTL Support';
//Clipboard
export const ClipboardTitle: string = "Clipboard";
export const ClipBoardOnTextInputTitle: string = "Clipboard on text input";
export const Copy: string = "Copy";
export const Cut: string = "Cut";
export const ClipboardOnTextAreaTitle: string = "Clipboard on textarea";
export const ClipboardOnParagraphTitle: string = "Clipboard on paragraph";
export const ClipboardParagraphText: string = "Copy from paragraph";
export const CopyPortionParagraphTitle: string = "Copy portion from paragraph";
export const CopyHighlightedText: string = "Copy highlighted text";

//Form Layout
export const FormLayoutTitle: string = "Form Layout";
//Form Wizard 1
export const FormWizardTitle: string = "Form Wizard ";
//form-wizard2
export const CustomHorizontalTitle: string = "Custom horizontal wizard";
export const Continue: string = "Continue";
export const Email: string = "Email";
export const ContactNumber: string = "Contact Number";
export const AadhaarNumber: string = "Aadhaar Number"
export const ZipCode: string = "Zip Code";
export const PAN: string = "PAN"
export const AgreeTerms: string = "Agree to terms and conditions";
export const CardNumber: string = "Card Number";
export const Expiration: string = "Expiration(MM/YY)";
export const CVVNumber: string = "CVV Number";
export const CardHolder: string = "Card Holder";
export const ChooseBanks: string = "Choose from these popular banks";
export const SuccessfullyCompleted: string = "Successfully Completed";
export const AccountType: string = "Select the type of account";
export const AccountName: string = "Account Name";
export const ContactDetails: string = "Contact details";
export const OrganizationName: string = "Organization Name";
export const JoinOrganizationType: string = "Join organization type";
export const OrganizationDescription: string = "Organization description";
export const BusinessVerticalTitle: string = "Business vertical wizard";
export const CustomVerticalTitle: string = "Custom vertical wizard";
export const BusinessWizardTitle: string = "Business horizontal wizard";

//two-factor
export const TwoFactorAuthenticationTitle: string = "Two-factor authentication";
export const FactorAuthentication: string = "2 factor authentication"
export const EmailVerificationTitle: string = "Email verification"
export const Verify: string = "Verify";
export const VerificationCodeTitle: string = "Verification code";
export const Submit: string = "Submit";

//Tables
export const ReactstrapTablesTitle: string = "Reactstrap Tables";
export const ReactstrapBasicTablesTitle: string = "Reactstrap Basic Tables";
//Basic-table
export const BasicTableWithBorderTitle: string = "Basic Table With Border Bottom Color";
export const InverseTableTitle: string = "Inverse Table";
export const HoverableRowsTitle: string = "Hoverable Rows With Horizontal Border";
export const InverseTablePrimaryTitle: string = "Inverse Table with Primary background";
export const CaptionTitle: string = "Caption";
export const UserList: string = "List of users";
export const TableHeadOptionsTitle: string = "Table head options";
export const StripedRowInverseTableTitle: string = "Striped Row with Inverse Table";
export const BreckpointSpecificTitle: string = "Breckpoint Specific";
export const ResponsiveLightBackgroundTitle: string = "Responsive Tables With Light Background";
export const SizingTablesTitle: string = "Sizing Tables";
export const CustomColorHoverStrippedTitle: string = "Custom Table Color With Hover And Stripped";
export const DashedBorderTitle: string = "Dashed Border";
export const NumberingWizardTitle: string = "Numbering wizard";
export const PlaceholderName: string = "Placeholder Name";
export const UploadDocumentation: string = "Upload Documentation";
export const AboveInformationCorrect: string = "All the above information is correct";
export const LinkedIn: string = "LinkedIn";
export const Github: string = "Git hub";
export const SelectState: string = "Select State";
export const GiveFeedback: string = "Give Feedback";
export const Congratulations: string = "Congratulations ";
export const StudentValidationFormTitle: string = "Student validation form";
export const Back: string = "Back";
export const Name: string = "Name";
export const AddProfile: string = "Add Profile";
export const PortfolioURL: string = " Portfolio URL"
export const ProjectDescriptionText: string = "project and write a description";
export const SocialLinks: string = " Social Links "
export const Twitter: string = " Twitter";
export const VerticalValidationWizardTitle: string = "Vertical validation wizard";
export const SelectPaymentMethod: string = "Select your payment method";
export const NetBanking: string = " NET BANKING"
export const SelectYourBank: string = " SELECT YOUR BANK";
export const Cvv: string = "CVV";
export const ShippingFormTitle: string = "Shipping form";
export const BillingInformation: string = "Billing Information ";
export const RememberMeNext: string = "Remember me for next time";
export const OtherNotes: string = "Other Notes";
export const ProceedToBack: string = "Proceed to back";
export const ProceedToNext: string = "Proceed to Next";
export const ShippingInformation: string = "Shipping Information"
export const SavedAddress: string = "Saved Address"
export const Information: string = "Information"
export const AddressType: string = "Address Type"
export const Close: string = "Close";
export const ShippingMethod: string = "Shipping Method"
export const PaymentInformation: string = "Payment Information"
export const OrderConfirmed: string = "Thank you! Your order is confirmed.";
export const CurrentCartTitle: string = "Current Cart";

//Forms
export const FormControlsTitle: string = "Form Controls";
//checkbox & radio
export const CheckboxAndRadioTitle: string = "Checkbox & Radio";
export const DefaultCheckboxTitle: string = "Default checkbox";
export const Indeterminate: string = "Indeterminate";
export const IndeterminateCheckbox: string = "Indeterminate checkbox";
export const CustomCheckboxTitle: string = "Custom checkbox";
export const BorderedCheckboxTitle = 'Bordered Checkbox';
export const PrimaryCheckbox = 'Primary - checkbox-primary';
export const SecondaryCheckbox = 'Secondary - checkbox-secondary';
export const SuccessCheckbox = 'Success - checkbox-success';
export const IconCheckboxTitle = 'Icon Checkbox';
export const CustomRadiosTitle = 'Custom radio';
export const FilledCheckboxTitle = 'Filled Checkbox';
export const WarningSolidCheckbox = 'Warning - checkbox-solid-warning';
export const DangerSolidCheckbox = 'Danger - checkbox-solid-danger';
export const InfoSolidCheckbox = 'Info - checkbox-solid-info';
export const DefaultRadioTitle = 'Default radio';
export const ImagesCheckboxTitle = 'Images with checkbox';
export const ImagesWithRadioTitle = 'Images with radio';
export const BorderedRadioTitle = 'Bordered Radio';
export const IconsRadioTitle = 'Icons Radio';
export const FilledRadioTitle = 'Filled Radio';
export const DefaultSwitchesTitle = 'Default switches';
export const InlineInputTypesTitle = 'Inline Input-types';
export const InlineSwitchesTitle: string = 'Inline Switches';
export const AnimatedButtonsTitle: string = "Animated buttons";
export const BasicRadioAndCheckboxTitle: string = "Basic radio and checkbox";
export const RadioToggleButtonsTitle: string = "Radio toggle buttons";
export const Checked: string = "Checked";
export const Radio: string = "Radio";
export const Disabled: string = "Disabled";
export const OutlinedCheckboxStylesTitle: string = "Outlined checkbox styles";
export const SingleToggle: string = "Single toggle";
export const CheckedSuccessRadio: string = "Checked success radio";
export const DarkRadio: string = "Dark radio";

//Input Mask
export const InputMaskTitle: string = "Input Mask";
export const DateFormatTitle: string = "Date Format";
export const Date: string = "Date";
export const DateFormatType: string = "Date format type";
export const TimeFormatTitle: string = "Time Format";
export const TimeFormatType: string = "Time format type";
export const HourMonthType: string = "Hour/month type";
export const DefaultInputMaskTitle: string = "Default Input Mask";
export const Currency: string = "Currency";
export const Prefix: string = "Prefix";
export const Delimiter: string = "Delimiter";
export const PhoneNumber: string = "Phone Number";
export const Tailprefix: string = "Tailprefix";

//Mega Options
export const MegaOptionsTitle: string = "Mega Options";
export const VariationRadioTitle: string = "Variation radio";
export const VariationCheckboxTitle: string = "Variation checkbox";
export const DefaultStyleTitle: string = "Default Style";
export const WithoutBordersStyleTitle: string = "Without borders style";
export const SolidBorderStyleTitle: string = "Solid border style";
export const OfferStyleBorderTitle: string = "Offer style border";
export const InlineStyleTitle: string = "Inline style";
export const VerticalStyleTitle: string = "Vertical style";
export const HorizontalStyleTitle: string = "Horizontal style";
export const MasterCard: string = "MasterCard";
export const Visa: string = "Visa";

//Form Widgets
export const FormWidgetsTitle: string = "Form Widgets";
//Datepicker
export const DatepickerTitle: string = "Datepicker";
export const DefaultCalendarTitle: string = "Default calendar";
export const ReactstrapCalendarTitle: string = "Reactstrap calendar";
export const DatePickerCardTitle: string = "Date picker";
export const DefaultDate: string = "Default Date";
export const HumanFriendly: string = "Human Friendly";
export const MinMaxValue: string = "Min-Max Value";
export const DisabledDates: string = "Disabled Dates";
export const MultipleDatesTitle: string = "Multiples Dates";
export const CustomizingConjunctionTitle: string = "Customizing Conjunction";
export const Range: string = "Range";
export const PreloadingDates: string = "Preloading Dates";
export const TimePickerTitle: string = "Time Picker";
export const HourPicker: string = "24-hour Time Picker";
export const TimePickerLimits: string = "Time Picker W/Limits";
export const PreloadingTime: string = "Preloading Time";
export const TimePickerRange: string = "TimePicker with Limited Time";
export const TimePickerMinMaxRange: string = "TimePicker with Min/Max Time";
export const DateWithTime: string = "Date With Time";
//touchspin
export const TouchspinTitle: string = "Touchspin";
export const DefaultTouchspinTitle: string = "Default touchspin";
export const OutlinedTouchspinTitle: string = "Outlined touchspin";
export const IconsWithPrefixAndPostfixTitle: string = "Icons with prefix and postfix";
export const Pre: string = "Pre";
export const Post: string = "Post";
export const ButtonsWithPrefixPostfixTitle: string = "Buttons with prefix and postfix";
export const RoundedTouchspinTitle: string = "Rounded touchspin";
//Switch
export const SwitchTitle: string = "Switch";
export const CustomSwitchTitle: string = "Custom switch";
export const DisabledOutlineSwitchTitle: string = "Disabled outline switch";
export const VariationOfSwitchesTitle: string = "Variation of switches";
//Charts
export const ChartsTitle: string = "Charts";
//Google chart
export const GoogleChartTitle: string = "Google Chart"
export const AreaChartTitle1: string = "Area Chart 1";
export const AreaChartTitle2: string = "Area Chart 2";
export const ColumnChartTitle1: string = "Column Chart 1";
export const ColumnChartTitle2: string = "Column Chart 2";
export const GanttChartTitle: string = "Gantt Chart";
export const LineChartTitle: string = "Line Chart";
export const ComboChartTitle: string = "Combo Chart";
export const BarChart2Title: string = "Bar-chart2";
export const WordTreeTitle: string = "Word Tree";
export const PieChart: string = "Pie Chart";
export const ChartJsChartTitle: string = "ChartJS Chart";
export const LineGraphTitle: string = "Line Graph";
export const RadarGraphTitle: string = "Radar Graph";
export const DoughnutChartTitle: string = "Doughnut Chart";
export const PolarChartTitle: string = "Polar Chart";

//Forms
export const BaseInputsTitle: string = "Base Inputs"

//Base-inputs
export const BasicFormTitle: string = "Simple Example";
export const ExampleTextarea: string = "Example textarea";
export const SizingTitle: string = "Sizing"
export const BasicInputTitle: string = "Basic Input Type Control"
export const PlaceHolder: string = "Place holder"
export const Number: string = "Number"
export const URL: string = "URL"
export const DateTime: string = "Date and time"
export const Time: string = "Time"
export const File: string = "File"
export const MaximumLength: string = "Maximum Length"
export const Color: string = "Color"
export const ReadOnly: string = "Read only"
export const Textarea: string = "Textarea"
export const FlatStyleTitle: string = "Flat Style"
export const ExampleSelect: string = "Example select"
export const ExampleMultipleSelect: string = "Example multiple select"
export const EdgesStyleTitle: string = "Edges Style";
export const RaiseStyleTitle: string = "Raise Style";

//Form Validation
export const FormValidationTitle: string = "Form Validation"
export const TooltipFormValidationTitle: string = "Tooltip form validation";
export const LooksGood: string = "Looks good!";
export const UserName: string = "Username";
export const City: string = "City";
export const Zip: string = "Zip";
export const SubmitForm: string = "Submit form";
export const BrowserDefaultsTitle: string = "Browser defaults";
export const ChooseFile: string = 'Choose file';
export const DescriptionLabel: string = 'Description';
export const AgreePolicy: string = ' I agree to the policies';
export const ConfirmationText: string = 'Are you sure the above information is true';
export const PayMethodTitle: string = "Select your payment method";
export const ValidationFormTitle: string = "Validation Form";

//Input Groups
export const InputGroupTitle: string = "Input Group"
export const ButtonAddonsTitle: string = "Button addons";
export const CustomFormsTitle: string = "Custom forms";
export const Options: string = "Options";
export const PixelstrapThemeTitle: string = "Select Your Favorite Pixelstrap theme"
export const FavoriteColorsTitle: string = 'Select Your Favorite Colors';
export const FavoriteChocolatesTitle: string = 'Select Your Favorite Chocolates';
export const FavoriteThemeTitle: string = 'Select Your Favorite Theme';
export const CustomFileInputTitle: string = "Custom file input";
export const Upload: string = 'Upload';
export const ButtonsWithDropdownsTitle: string = "Buttons with dropdowns";
export const SegmentedButtonsTitle: string = "Segmented buttons";
export const Info: string = 'Info';
export const Secondary: string = 'Secondary';
export const CheckboxesAndRadiosTitle: string = "Checkboxes and radios";
export const SmallInput: string = "Small";
export const DefaultInputText: string = "Default";
export const LargeInput: string = "Large";
export const MultipleInputsTitle: string = "Multiple inputs";
export const FirstAndLastName: string = "First and last name";
export const BasicInputGroupsTitle: string = "Basic input groups";
export const Basic: string = 'Basic';
export const YourVanityUrl: string = 'Your vanity URL';
export const Wrapping: string = 'Wrapping';
export const VariationAddonsTitle: string = "Variation of addons";
export const LeftAddon = 'Left Addon';
export const RightAddon = 'Right Addon';
export const JointAddon = 'Joint Addon';
export const LeftAndRightAddon = 'Left & Right Addon';
export const SolidStyle = 'Solid style';
export const FlatStyle = 'Flat style';
export const RaiseStyle = 'Raise style';
//Icons
export const IconsTitle: string = "Icons";
export const FontAwesomeTitle: string = "Font Awesome";
export const FeatherTitle: string = "Feather Icon";
export const ThemifyIconTitle: string = "Themify Icon";
export const IconlyIconTitle: string = "Iconly Icon";

//Charts
//Apex chart
export const ApexChartTitle: string = "Apex chart";
export const BasicAreaChartTitle: string = "Basic Area Chart";
export const AreaSpalineChartTitle: string = "Area Spaline Chart";
export const BarChartTitle: string = "Bar Chart";
export const ColumnChartTitle: string = "Column Chart";
export const BubbleChartTitle: string = "3d Bubble Chart";
export const SteplineChartTitle: string = "Stepline Chart";
export const PieChartTitle: string = "Pie Chart";
export const DonutChartTitle: string = "Donut Chart";
export const MixedChartTitle: string = "Mixed Chart";
export const CandlestickChartTitle: string = "Candlestick Chart";
export const RadarChartTitle: string = "Radar Chart";
export const RadialBarChartTitle: string = "Radial Bar Chart";

//Bonus ui
//Creative Card
export const CreativeCardTitle: string = "Creative Card";
export const BorderLeftTitle: string = "Border Left";
export const BorderRightTitle: string = "Border Right";
export const BorderTopTitle: string = "Border Top";
export const BorderBottomTitle: string = "Border Bottom";
export const BorderPrimaryTitle: string = "Border Primary State";
export const BorderWarningTitle: string = "Border Warning State"
export const BorderSecondaryTitle: string = "Border Secondary State";
export const AbsoluteCard: string = "Absolute Card";
//Timeline
export const TimelineTitle: string = "Timeline";
export const BasicTimelineTitle: string = "Basic Timeline";
export const HoverTimelineTitle: string = "Hovering Timeline";
export const VariationTimelineTitle: string = "Variation Timeline";
export const HorizontalTimelineTitle: string = "Horizontal Timeline";

//Buttons
export const ButtonsTitle: string = "Buttons";
export const DefaultButtonTitle: string = "Default buttons";
export const FlatButtonTitle: string = "Flat button";
export const EdgeButtonTitle: string = "Edge buttons";
export const ButtonsGroupTitle: string = "Buttons group";
export const LargeButtonTitle: string = "Large buttons";
export const SmallButtonTitle: string = "Small buttons";
export const ActiveButtonTitle: string = "Active buttons";
export const DisabledButtonTitle: string = "Disabled buttons";
export const OutlineButtonTitle: string = "Outline buttons";
export const BoldButtonTitle: string = "Bold border outline button";
//Breadcrumb
export const BreadcrumbTitle: string = "Breadcrumb";
export const DefaultBreadcrumbTitle: string = "Default Breadcrumb"
export const DividerBreadcrumbTitle: string = "Divider Breadcrumb"
export const WithIconBreadcrumbTitle: string = "With Icons Breadcrumb"
export const SimpleBreadcrumbTitle: string = "Simple Breadcrumb"
export const BreadcrumbAlignmentTitle: string = "Breadcrumb Alignment"
export const ColoredBreadcrumbTitle: string = "Colored Breadcrumb"
//Range Slider
export const RangeSliderTitle: string = "Range Slider";
export const DefaultRangeTitle: string = "Default Range Slider";
export const NagativeRangeTitle: string = "Negative Values Slider";
export const DisabledSliderTitle: string = "Disabled Range Slider";
export const PointFormatedLabelTitle: string = "Point Formated Label";
export const PostfixFormatedLabelTitle: string = 'Postfix Formated Label';
export const DraggableTitle: string = "Draggable Range Slider";
//ImageCropper
export const ImageCropperTitle: string = "Image Cropper";
//Basic card
export const BasicCardTitle: string = "Basic Card";
export const FlatCardTitle: string = "Flat Card";
export const WithoutShadowTitle: string = "Without shadow Card";
export const IconHeadingTitle: string = "Icon In Heading";
export const DarkCardTitle: string = "Dark Color Card";
export const InfoColorHeaderTitle: string = "Info Color Header";
export const InfoColorBodyTitle: string = "Info Color Body";
export const InfoColorFooterTitle: string = "Info Color Footer";
//Sweetalert
export const SweetalertTitle: string = "Sweetalert2";
export const BasicAlertTitle: string = "Basic Example";
export const AdvanceAlertTitle: string = "Advance Sweetalert";
export const UniqueSweetalertTitle: string = "Unique Sweetalert";
export const DirectionSweetalertTitle: string = "Direction Sweetalert";
export const InputSweetalertTitle: string = "Input sweetalert";
export const GithubAvatarTitle: string = "Github Avatar";
export const RtlSupportTitle: string = "RTL Support";
export const SuccessMessageTitle: string = "Success Message";
export const DangerAlertTitle: string = "Danger Alert";
//Slider
export const SliderTitle: string = "Slider";
export const DefaultSliderTitle: string = "Default swiper slider";
export const WithControlsTitle: string = "With Controls";
export const AutoPlayVariantTitle: string = "Auto Play Variant";
export const MouseOverTitle: string = "Mouse Wheel Variant";
export const WithIndicatorsTitle: string = "With Indicators";
export const WithCaptionTitle: string = "With Captions";
export const CrossFadeTitle: string = "Cross-Fade";
export const IndividualCarouselTitle: string = "Individual Carousel-Item Interval";
export const DisableTouchSwipingTitle: string = "Disable Touch Swiping";
export const DarkVariantTitle: string = "Dark Variant";
//Pagination
export const PaginationTitle: string = "Pagination";
export const DefaultPaginationTitle: string = "Default Pagination";
export const WithDisabledTitle: string = "With Disabled";
export const IconPaginationTitle: string = "With Icons";
export const ActiveDisablePageTitle: string = "Pagination With Active And Disabled";
export const WithOutlineTitle: string = "With Outline";
export const RoundedPaginationTitle: string = "Rounded Pagination"
export const PaginationAlignTitle: string = "Pagination Alignment"
export const PaginationSizeTitle: string = "Pagination Size"
export const CopyText: string = "Copy text";
//Dropzone
export const DropzoneTitle: string = "Dropzone";
export const DefaultDropzoneTitle: string = "Default File Upload";
export const ImagePreviewTitle: string = "Image Preview";
export const SingleFileuploadTitle: string = "Single File Upload";
export const MultiFileUploadTitle: string = "Multi File Upload";
//Tour
export const TourTitle: string = "Tour";
//Ribbons
export const RibbonsTitle: string = "Ribbons";
export const LeftSideRibbonsTitle: string = "Variations Of Left Ribbons"
export const RightSideRibbonTitle: string = "Variations Of Right Ribbons"
//Rating
export const RatingTitle: string = "Rating";
export const RatingFeedbackTitle: string = "Rating with feedback";
export const PillRatingTitle: string = "Pill Rating";
export const ReversedRatingTitle: string = "Reversed Rating";
export const StarRatingTitle: string = "Star Rating";
export const HalfStarRatingTitle: string = "Half Star Rating";
export const ThumbUpDownRate: string = "Thumb Up/Down Rating";

//auth
export const SignInAccount: string = "Sign in to account";
export const RememberPassword: string = "Remember password";
export const ForgotPassword: string = "Forgot password?"
export const SignInWith: string = "Or Sign in with";
export const DontHaveAccount: string = "Don't have account?"
export const CreateAccount: string = "Create Account";
export const CreateYourAccount: string = "Create your account";
export const EmailAddress: string = "Email address";
export const Password: string = "Password";
export const SignIn: string = "Sign in";
//pricing
export const PricingTitle: string = "Pricing";
export const BecomeMemberTitle: string = "Become Member";
export const SimplePricingTitle: string = "Simple Pricing Card";
export const Purchase: string = "Purchase";
export const SignUp: string = "Sign Up";

//Invoice
export const InvoiceTitle: string = "Invoice";
//Ecommerce
export const CategoryTitle: string = "Category";
export const ProductListTitle: string = "Product list";
export const PaymentDetailsTitle: string = "Payment Details";
export const CreditCardTitle: string = "Credit Card";
export const DebitCardTitle: string = "Debit Card";
export const CodTitle: string = "COD";
export const EmiTitle: string = "EMI";
export const NetBankingTitle: string = "Net Banking";
export const OrderHistoryTitle: string = "Order History";
export const DatatableOrderHistoryTitle: string = "Datatable Order History";
export const CartTitle: string = "Cart";
export const WishlistTitle: string = "Wishlist";
//checkout
export const CheckoutTitle: string = "Checkout";
export const BillingDetails: string = "Billing Details";
export const PlaceOrder: string = "Place Order";
export const TownCity: string = "Town/City";
export const StateCountry: string = "State/Country";
export const CheckMeOut: string = "Check me out";
export const SidebarIconTitle: string = "Sidebar icon";
export const LayoutTypeTitle: string = "Layout type:";